import { MagnifyingGlassIcon } from "components/page-components/Icons/small"
import React from "react"

export const HeaderInternalSearchButton = ({ open_search_modal }) => {
  return (
    <button
      className={`button is-tertiary is-header-search`}
      style={{ height: "100%", minWidth: 80 }}
      onClick={open_search_modal}
      aria-label="Seiten-Suche"
    >
      <MagnifyingGlassIcon {...{ size: 0.8 }} />
    </button>
  )
}
